// extracted by mini-css-extract-plugin
export default {"table":"PatientConsentPrograms_table__64ymp","actionSeparator":"PatientConsentPrograms_actionSeparator__Kt7in","actionRemove":"PatientConsentPrograms_actionRemove__WD5JZ"};